// Naming a meal you're about to keep (and renaming one later) — a small
// centered dialog, prefilled so one tap on Save is always enough.
import { useState } from "react";
import { useT } from "../lib/i18n";
import { SheetShell } from "./SheetShell";
import { Button } from "./ui/Button";

interface Props {
  initial: string;
  onSave: (name: string) => void | Promise<void>;
  onClose: () => void;
}

export function SaveMealNameSheet({ initial, onSave, onClose }: Props) {
  const t = useT();
  const [name, setName] = useState(initial);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true);
    try { await onSave(name.trim().slice(0, 120)); onClose(); }
    finally { setBusy(false); }
  }

  return (
    <SheetShell variant="center" onClose={onClose}>
      <form onSubmit={submit} className="space-y-4 pt-1">
        <h2 className="text-lg font-semibold">{t("saved.name_title")}</h2>
        <input
          className="input"
          value={name}
          onChange={(e) => setName(e.target.value.slice(0, 120))}
          placeholder={t("saved.name_placeholder")}
          autoFocus
        />
        <Button type="submit" fullWidth disabled={busy || !name.trim()}>
          {t("more_goals.save")}
        </Button>
      </form>
    </SheetShell>
  );
}
